/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_Connect_FailedInputs */

const th_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เชื่อมต่อห้องไม่ได้ โปรดลองอีกครั้ง`)
};

const en_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not connect to the room. Try again.`)
};

const ja_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ルームに接続できませんでした。もう一度お試しください。`)
};

const zh_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法连接到房间。请重试。`)
};

const es_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha podido conectar con la sala. Inténtalo de nuevo.`)
};

const pt_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível conectar à sala. Tente de novo.`)
};

const id_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak bisa terhubung ke ruang. Coba lagi.`)
};

const fr_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de se connecter au salon. Réessayez.`)
};

const tl_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi makakonekta sa silid. Subukang muli.`)
};

const vi_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không kết nối được tới phòng. Thử lại.`)
};

const ko_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방에 연결할 수 없습니다. 다시 시도하세요.`)
};

const de_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zum Raum nicht möglich. Versuche es erneut.`)
};

const ru_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось подключиться к комнате. Попробуйте снова.`)
};

const tr_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaya bağlanılamadı. Yeniden deneyin.`)
};

const it_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile connettersi alla stanza. Riprova.`)
};

const pl_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się połączyć z pokojem. Spróbuj ponownie.`)
};

const uk_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося підключитися до кімнати. Спробуйте ще раз.`)
};

const hi_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कक्ष से जुड़ नहीं सके। फिर कोशिश करें।`)
};

const ar_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر الاتصال بالغرفة. أعد المحاولة.`)
};

const ms_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat menyambung ke bilik. Cuba lagi.`)
};

const bn_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কক্ষে যুক্ত হওয়া যায়নি। আবার চেষ্টা করুন।`)
};

const zh_tw2_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法連線到房間。請再試一次。`)
};

const zh_hk2_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法連線到房間。請再試一次。`)
};

const ur_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کمرے سے جڑ نہیں سکے۔ دوبارہ کوشش کریں۔`)
};

const fa_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اتصال به اتاق ممکن نشد. دوباره تلاش کنید.`)
};

const sw_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haikuweza kuunganishwa na chumba. Jaribu tena.`)
};

const nl_meeting_test_connect_failed = /** @type {(inputs: Meeting_Test_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon geen verbinding maken met de ruimte. Probeer opnieuw.`)
};

/**
* | output |
* | --- |
* | "Could not connect to the room. Try again." |
*
* @param {Meeting_Test_Connect_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_connect_failed = /** @type {((inputs?: Meeting_Test_Connect_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_Connect_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_connect_failed(inputs)
	if (locale === "ja") return ja_meeting_test_connect_failed(inputs)
	if (locale === "zh") return zh_meeting_test_connect_failed(inputs)
	if (locale === "es") return es_meeting_test_connect_failed(inputs)
	if (locale === "pt") return pt_meeting_test_connect_failed(inputs)
	if (locale === "id") return id_meeting_test_connect_failed(inputs)
	if (locale === "fr") return fr_meeting_test_connect_failed(inputs)
	if (locale === "tl") return tl_meeting_test_connect_failed(inputs)
	if (locale === "vi") return vi_meeting_test_connect_failed(inputs)
	if (locale === "ko") return ko_meeting_test_connect_failed(inputs)
	if (locale === "de") return de_meeting_test_connect_failed(inputs)
	if (locale === "ru") return ru_meeting_test_connect_failed(inputs)
	if (locale === "tr") return tr_meeting_test_connect_failed(inputs)
	if (locale === "it") return it_meeting_test_connect_failed(inputs)
	if (locale === "pl") return pl_meeting_test_connect_failed(inputs)
	if (locale === "uk") return uk_meeting_test_connect_failed(inputs)
	if (locale === "hi") return hi_meeting_test_connect_failed(inputs)
	if (locale === "ar") return ar_meeting_test_connect_failed(inputs)
	if (locale === "ms") return ms_meeting_test_connect_failed(inputs)
	if (locale === "bn") return bn_meeting_test_connect_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_connect_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_connect_failed(inputs)
	if (locale === "ur") return ur_meeting_test_connect_failed(inputs)
	if (locale === "fa") return fa_meeting_test_connect_failed(inputs)
	if (locale === "sw") return sw_meeting_test_connect_failed(inputs)
	if (locale === "nl") return nl_meeting_test_connect_failed(inputs)
	return en_meeting_test_connect_failed(inputs)
});